module.exports = __webpack_public_path__ + "img/Number=89.09799bf0.png";